import PageAccueil from "../pages/PageAccueil";
import PrixMoyenProduitParProvince from "../pages/PrixMoyenProduitParProvince";
import PrixCategorieParProvince from "../pages/PrixCategorieParProvince";


export default [
    {
        id: "accueil",
        component: <PageAccueil key="accueil"/>,
        duration: 10000,
    },
    {
        id: "PrixMoyenProduitParProvince",
        component: <PrixMoyenProduitParProvince produit="Tomates" key="tomates"/>,
        duration: 10000,
    },
    {
        id: "PrixMoyenProduitParProvince",
        component: <PrixMoyenProduitParProvince produit="Gombo sec" key="gombo sec"/>,
        duration: 10000,
    },
    {
        id: "PrixMoyenProduitParProvince",
        component: <PrixMoyenProduitParProvince produit="Maïs grain" key="mais grain"/>,
        duration: 10000,
    },
   
     {
        id: "PrixMoyenProduitParProvince",
        component: <PrixMoyenProduitParProvince produit="Ovins" key="ovins"/>,
        duration: 10000,
    },
    

    {
        id: "PrixCategorieParProvince",
        component: <PrixCategorieParProvince key="prix-categorie-par-province"/>,
        duration: 10000,
    },
];